import React from "react";
import { connect } from "react-redux";
import { reduxForm, Field, SubmissionError } from "redux-form";
import { compose, withHandlers, withState } from "recompose";
import {find, forEach, concat} from "lodash";
import classNames from "classnames";
import Button from "react-md/lib/Buttons/Button";
import FileInput from "react-md/lib/FileInputs";

import TextField from "../form/TextField";
import SelectField from "../form/SelectField";
import AutocompleteField from "../form/AutocompleteField";
import * as Validation from "../form/Validation";

import { formShowMore } from "../../actions/appActions";
import { newRequest } from "../../actions/requestActions";
import { getTypeBySearch } from "../../actions/resourceActions";

import { currency } from "../../enums";

import Translation from "../../Atollon/Translation";

const customTypeDefault = [
  { label: "Obecné", value: "Obecné" },
  { label: "Poptávka", value: "Poptávka" },
  { label: "Stížnost", value: "Stížnost" }
];
var customType = customTypeDefault;

const optionsSeriousness = [
  { label: "Nejnižší", value: "1" },
  { label: "Nízká", value: "3" },
  { label: "Normální", value: "5" },
  { label: "Vyšší", value: "7" },
  { label: "Nejvyšší", value: "10" }
];
const optionsTax = [
  { label: "Bez daně", value: "WITHOUT_TAX" },
  { label: "Včetně daně", value: "WITH_TAX" }
];

function log()
{
    console.log.apply( null, concat( [ '%cRequestNewForm.js qqq', 'color:pink' ], arguments ));
};

const SenderAndRequestValidation = {

    validOptionsForSender: null,
    validOptionsForTo: null,

    // Menuitem{ name, value }
    setValidOptionsForSender: ( optionsAsMenuitems ) =>
    {
        this.validOptionsForSender = optionsAsMenuitems;
    },

    // Menuitem{ name, value }
    setValidOptionsForTo: ( optionsAsMenuitems ) =>
    {
        this.validOptionsForTo = optionsAsMenuitems;
    },

    isValidTo: ( to ) =>
    {
        const opt = this.validOptionsForTo;
        const is = !! find( opt, (o) => o.value === to );
        log( 'is valid to', { to, opt, is });
        return is;
    },

    isValidSender: ( sender ) =>
    {
        const opt = this.validOptionsForSender;
        const is = !! find( opt, (o) => o.value === sender );
        log( 'is valid sender', { sender, opt, is });
        return is;
    }
};

const RequestNewReceivedForm = ( formInput ) => {
    var {
        handleSubmit,
            formShowMore,
            showMore,
            user,
            projects,
            getTypeBySearch,
            setDays,
            setHours,
            setMinutes,
            initialValues,
            change,
            users,
            setAutocompleteContent,
            providers
    } = formInput;

    var requestType_getNewStateSomehow = function ( )
    {
        // TODO:
        return customTypeDefault;
    };

    customType = requestType_getNewStateSomehow();

  const optionsProjects = [{ label: "Žádný projekt", value: "NO_PROJECT" }];
  if (projects && projects.item) {
    forEach(projects.item, item =>
      optionsProjects.push({ label: item.name, value: item.identifier })
    );
  }

  const optionsUser = [
    {
      label: `${user.name ? `${user.name} (` : ""}${user.identifier}${user.name
        ? `)`
        : ""}`,
      value: user.identifier
    }
  ];

  const optionsAutocomplete = [];
  if (providers)
  {
        forEach(providers.item, item =>
            optionsAutocomplete.push({
                label: `${item.name
                    ? `${item.name} (`
                    : ""}${item.identifier}${item.name ? `)` : ""}`,
                value: item.identifier
            })
        );
  }
  if (users)
  {

    forEach(users.item, item =>
      optionsAutocomplete.push({
        label: `${item.name
          ? `${item.name} (`
          : ""}${item.identifier}${item.name ? `)` : ""}`,
        value: item.identifier
      })
    );
  }

    // https://atollon.com/atollon-web/rest/server/atollon.net/requestResource/atollon.com
    // {
    //  requestCustomTypes
    // }requestCustomTypes
    // getOrganization = (hostId, serverId, organizationId)
    SenderAndRequestValidation.setValidOptionsForSender( initialValues.requestType === "NEW"? optionsUser : optionsAutocomplete );
    SenderAndRequestValidation.setValidOptionsForTo( initialValues.requestType === "NEW"? optionsAutocomplete : optionsUser );

  return (
    <form className="form" onSubmit={handleSubmit}>
      <div className="flex-row flex-space-between">
        {initialValues.requestType === "NEW" ? (
          <Field
            name="sender"
            label="Požadavek od"
            component={SelectField}
            menuItems={optionsUser}
            validate={[Validation.required]}
          />
        ) : (
          <Field
            component={AutocompleteField}
            label="Požadavek od"
            name="sender"
            data={optionsAutocomplete}
            onChange={(e, value) => getTypeBySearch("PERSON,ORGANIZATION", value)}
            onAutocomplete={value => {
                log('on autocomplete', {value})
                change("sender", value);
                return setAutocompleteContent(value)
            }}
            validate={[Validation.required]}
          />
        )}
        <Field
          name="customType"
          label="Typ požadavku"
          component={SelectField}
          menuItems={customType}
          validate={[Validation.required]}
        />
      </div>
      <div className="">
        {initialValues.requestType === "NEW" ? (
          <Field
            component={AutocompleteField}
            label={Translation("request-new-recipient","Komu")}
            name="to"
            data={optionsAutocomplete}
            onChange={(e, value) =>
                getTypeBySearch("PERSON,ORGANIZATION", value)
            }
            onAutocomplete={value => {
                change("to", value); // set new value to form
                return setAutocompleteContent(value); // FIXME: does ti return anything?
              }
            }
            validate={[Validation.required]}
          />
        ) : (
          <Field
            name="to"
            label={Translation("request-new-recipient","Komu")}
            component={SelectField}
            menuItems={optionsUser}
            validate={[Validation.required]}
          />
        )}
        <Field
          name="severity"
          label="Vážnost"
          component={SelectField}
          menuItems={optionsSeriousness}
          validate={[Validation.required]}
        />
      </div>
      <Field
        component={TextField}
        label="Předmět"
        name="subject"
        placeholder="Zde napiště shrnutí vašeho požadavku"
        validate={[Validation.required]}
      />
      <Field component={TextField} label="Zpráva" name="messageBody" rows={5} />
      <div className="flex-row margin-bottom-small">
        <div className="flex-row-normal flex-centered">
          Dodatky:
          <Button
            flat
            primary
            label={!showMore ? "Zobrazit vše" : "Zobrazit méně"}
            onClick={() => formShowMore(!showMore)}
            className="btn btn-primary md-btn md-btn-text"
          />
        </div>
      </div>
      <div className={classNames({ hidden: !showMore })}>
        <div className="flex-row flex-bottom">
          Projekt:
          <Field
            name="project"
            component={SelectField}
            menuItems={optionsProjects}
            className="margin-left-small"
          />
        </div>
        <div className="flex-row flex-bottom">
          <div className="flex-row-normal">Odhadované trvání:</div>
          <div className="flex-row-normal margin-left-small">
            <Field
              name="days"
              label="Dny"
              component={TextField}
              type="number"
              validate={[Validation.emptyOrgreaterEqual0]}
            />
            <Field
              name="hours"
              label="Hodiny"
              component={TextField}
              type="number"
              validate={[Validation.emptyOrgreaterEqual0]}
            />
            <Field
              name="minutes"
              label="Minuty"
              component={TextField}
              type="number"
              validate={[Validation.emptyOrgreaterEqual0]}
            />
          </div>
        </div>
        <div className="flex-row flex-bottom">
          Cena
          <div className="flex-row-normal flex-align-center margin-left-small">
            <Field
              name="priceCurrency"
              component={SelectField}
              menuItems={currency}
            />
            <Field
              component={TextField}
              name="priceAmount"
              type="number"
              validate={[Validation.emptyOrgreaterEqual0]}
            />
          </div>
          <div className="flex-row-normal flex-align-center">
            <Field
              name="withOrWithoutTax"
              component={SelectField}
              menuItems={optionsTax}
            />
            <Field
              component={TextField}
              name="priceTaxAmount"
              type="number"
              validate={[Validation.emptyOrgreaterEqual0]}
            />%
          </div>
        </div>

          {initialValues.requestType === "NEW" ?
              null :
              <div>
                  {/*<div className="flex-row flex-bottom">
                  Přílohy:
                  <div className="margin-left-small">
                      <FileInput
                          id="fileInput"
                          onChange={() => null}
                          accept="image/*"
                          name="files"
                      />
                  </div>
              </div>*/}
              </div>
          }
      </div>
      <div className="flex-row flex-right">
        <Button
          flat
          primary
          label="Odeslat"
          type="submit"
          className="btn btn-primary touchButton-3"
        />
      </div>
    </form>
  );
};

export default compose(
  connect(
    ({ app: { form: { showMore } }, resource: { projects, users } }) => ({
      showMore,
      projects,
      users
    }),
    {
      formShowMore,
      newRequest,
      getTypeBySearch
    }
  ),
  withState("autocompleteContent", "setAutocompleteContent", ""),
  withHandlers({
    onSubmit: ({ autocompleteContent }) => async (
      formData,
      dispatch,
      props
    ) => {
      const { newRequest, history, initialValues } = props;
      const {
        sender,
        to,
        customType,
        severity,
        subject,
        messageBody,
        project,
        priceCurrency,
        priceAmount,
        priceTaxAmount,
        withOrWithoutTax,
        days,
        hours,
        minutes
      } = formData;

      if (
        ((!priceAmount || priceAmount === "") &&
          !(!priceTaxAmount || priceTaxAmount === "")) ||
        (!(!priceAmount || priceAmount === "") &&
          (!priceTaxAmount || priceTaxAmount === ""))
      )
      {
        throw new SubmissionError({
          priceTaxAmount: "Vyplňte cenu i daň."
        });
      }

      const { user, users } = props;
      log('SUBMIT',{ to, autocompleteContent, user, users });

      if( !SenderAndRequestValidation.isValidSender( sender ))
      {
            throw new SubmissionError({
                sender: "Odesílatel nexistuje"
            });
      }

      if( !SenderAndRequestValidation.isValidTo( to ))
      {
            throw new SubmissionError({
                to: "Adresát neexistuje"
            });
      }

      const estimatedDuration =
        (days && days !== "" ? Number(days) * 24 * 60 : 0) +
        (hours && hours !== "" ? Number(hours) * 60 : 0) +
        (minutes && minutes !== "" ? Number(minutes) : 0);

      // return;

      const response = await newRequest(
        sender,
        to,
        customType,
        severity,
        subject,
        messageBody,
        project === "NO_PROJECT" ? undefined : project,
        estimatedDuration === 0 ? undefined : estimatedDuration,
        !priceAmount || !priceTaxAmount ? undefined : priceCurrency,
        withOrWithoutTax === "WITHOUT_TAX"
          ? priceAmount
          : priceAmount / (priceTaxAmount / 100 + 1),
        withOrWithoutTax === "WITHOUT_TAX"
          ? priceTaxAmount
          : priceAmount - priceAmount / (priceTaxAmount / 100 + 1)
      );

      if (response) history.push(`/requests/${response.hash}`);
      else
        throw new SubmissionError({
          messageBody: "Požadavek se nepodařilo vytvořit."
        });
    }
  }),
  reduxForm({ form: "requestForm", enableReinitialize: true })
)(RequestNewReceivedForm);



// WEBPACK FOOTER //
// ./src/components/requestNewReceived/RequestNewReceivedForm.js